export const cacheKeys = {
  getTrip: 'getTrip',
  getTrips: 'getTrips',
  createTrip: 'createTrip',
  editTrip: 'editTrip',
  patchTrip: 'patchTrip',
  deleteTrip: 'deleteTrip',
};
